var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('b-btn',{on:{"click":function($event){return _vm.signIn()}}},[_vm._v("Login")])],1),_c('div',{staticClass:"col-8"})])])}
var staticRenderFns = []

export { render, staticRenderFns }